// Section2.jsx - Premium Value Proposition Component
import React from 'react';
import './Sections.css';

const Section2 = () => {
  return (
    <section className="section-2">
      <div className="paycis-container">
        <div className="section-2-content">
          <h2 className="section-2-headline">
            Saving contractors and builders <br />
            hours every week.
          </h2>
          <p className="section-2-sub">
             No mistakes. No admin. No paperwork 
          </p>
        </div>
      </div>
    </section>
  );
};

export default Section2;